// Shown while the incoming count isn't known yet (e.g. the hub's first load, before the lists-search
// resolves), so the skeleton still fills a plausible page instead of collapsing to nothing.
export const FALLBACK_SKELETON_ROWS = 10;

// Skeleton rows are sized to the rows actually incoming so real rows drop in with no layout shift: a
// short list never shimmers a full page, and a full page always shows the cap. `total` is the known
// row count for the query (the List Detail header playerCount, or the hub's prior lists-search total).
// When it isn't known yet, fall back to a plausible partial page.
export const computeSkeletonRowCount = (total, page, pageSize) => {
    if (!Number.isFinite(total)) {
        return FALLBACK_SKELETON_ROWS;
    }
    const remaining = total - ((page - 1) * pageSize);
    return Math.max(0, Math.min(pageSize, remaining));
};
